import React from 'react';
import { Mail } from 'lucide-react';
import { Badge } from '@/Components/shadcn';

interface TotalEmailsCellProps {
    value: React.ReactNode;
}

const TotalEmailsCell = ({ value }: TotalEmailsCellProps) => {
    if (typeof value === 'string') {
        return <p className="mx-auto overflow-hidden text-sm text-ellipsis">{value}</p>;
    }

    return (
        <Badge variant="secondary" className="mx-auto gap-1">
            <Mail className="h-3.5 w-3.5" />
            <span className="text-sm">{value}</span>
        </Badge>
    );
};

export default TotalEmailsCell;
